import React, { useState } from "react";
import { Input } from "antd";
import { Search } from "lucide-react";

function SearchBar({ placeholder, searchHandler, filters, pagination, onChange, searchValue, searchWrapperClass, inputClassName, inputIconClass }) {
    const [value, setValue] = useState("");

    const onSearchHandler = (value) => {
        if (searchHandler) {
            searchHandler({
                ...filters,
                page: 1,
                paginate: pagination?.per_page || 10,
                keyword: value,
            });
        }
    };

    const onChangeHandler = (value) => {
        if (onChange) {
            onChange(searchValue);
        }else if(value === ''){
                if (searchHandler) {
                searchHandler({
                    ...filters,
                    page: 1,
                    paginate: pagination?.per_page || 10,
                    keyword: value,
                });
            }
        }
    }

    return (
        <div className="w-full">
        <div
            className={`relative flex items-center w-full rounded-lg border border-gray-50 bg-gray-50
                        focus-within:border-emerald-500 focus-within:ring-emerald-500/50
                        focus-within:ring-2 focus-within:outline-none h-9 dark:bg-white/30 dark:border-gray-300
                        ${searchWrapperClass} 
                      `}
        >
            <Search className={`absolute left-3 text-gray-400 w-4 h-4 ${inputIconClass}`} />
            <Input
                placeholder={placeholder ?? "Keyword"}
                value={value}
                variant="borderless"
                allowClear
                className={`
                    pl-9 pr-3 text-[13px] sm:text-[14px]
                    disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 placeholder-white 
                    ${inputClassName}
                `}
                onChange={(e) => {
                    setValue(e.target.value);
                    onChangeHandler(e.target.value); 
                }}
                onPressEnter={() => onSearchHandler(value)}
            />
        </div>
        </div>
    );
}

export default SearchBar;
